/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureResourceBase extends models.TagPostureBase {
    constructor() {
        super();
        this.setDiscriminator("TagPostureResourceBase");
    }

    getFixupPrototypeFunction() { return TagPostureResourceBase.fixupPrototype; }

    static newInstance(model: Partial<TagPostureResourceBase>): TagPostureResourceBase {
        let obj = Object.assign(new TagPostureResourceBase(), model);
        TagPostureResourceBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureResourceBase>): TagPostureResourceBase {
        if (!model) return null;
        return TagPostureResourceBase.newInstance(<TagPostureResourceBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureResourceBase) {
        if (!obj) return;

        models.TagPostureResourceBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureResourceBase): boolean {
        if (models.TagPostureBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TagPostureResourceBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Identifier of the resource
     */
    resource_id: string;

    /**
     * Cloud resource id
     */
    cloud_resource_id: string;

    /**
     * Name of the resource
     */
    resource_name: string;

    /**
     * Category of the resource
     */
    resource_category: string;

    /**
     * Component of the resource
     */
    resource_component: string;

    /**
     * Type of the resource
     */
    resource_type: string;

    /**
     * Location of the resource
     */
    resource_region: string;

    /**
     * Resource_group/Zone/Region for the resource
     */
    resource_filter: string;

}
